import { InteractionAnalyticsMap } from "@abbvie-epi/common/models";

export const analyticsInteractions: InteractionAnalyticsMap = {
    // Global Tags
    // Videos
    "base-video-interaction": {
        link: {
            type: "Video-interaction"
        },
        component: {
            name: "video player",
            position: "content",
            type: "content"
        },
        content: {
            type: "Video"
        },
        interaction: {
            type: "Video play"
        }
    },
    "global-bottom-nav-back": {
        link: {
            type: "internal"
        },
        component: {
            name: "cta",
            title: "BACK TO",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },
    "global-bottom-nav-continue": {
        link: {
            type: "internal"
        },
        component: {
            name: "cta",
            title: "CONTINUE TO",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },
    "global-references-accordion-expand": {
        link: {
            name: "References - Expand",
            title: "References - Expand",
            type: "internal"
        },
        component: {
            name: "cta",
            title: "References",
            position: "content",
            type: "content"
        },
        content: {
            type: "accordion"
        },
        interaction: {
            type: "link"
        }
    },
    "global-references-accordion-close": {
        link: {
            name: "References - Close",
            title: "References - Close",
            type: "internal"
        },
        component: {
            name: "cta",
            title: "References",
            position: "content",
            type: "content"
        },
        content: {
            type: "accordion"
        },
        interaction: {
            type: "link"
        }
    },
    "global-modal-accordion-base": {
        link: {
            type: "internal"
        },
        component: {
            name: "modal",
            position: "content",
            type: "content"
        },
        content: {
            type: "accordion"
        },
        interaction: {
            type: "link"
        }
    },

    // Header
    "header-site-logo": {
        link: {
            name: "Site Logo",
            title: "Site Logo",
            url: "home"
        },
        component: {
            title: "Site Logo"
        }
    },
    "header-hamburger-menu-open": {
        link: {
            name: "Hamburger Menu",
            title: "Hamburger Menu"
        },
        component: {
            title: "Top Navigation Menu"
        }
    },
    "header-hamburger-menu-close": {
        link: {
            name: "Menu Close",
            title: "X"
        },
        component: {
            title: "Top Navigation Menu"
        }
    },
    "header-home": {
        link: {
            name: "Home",
            title: "Home",
            url: "home"
        },
        component: {
            title: "Home"
        }
    },
    "header-what-is-epi": {
        link: {
            name: "What is EPI?",
            title: "What is EPI?",
            url: "what-is-epi"
        },
        component: {
            title: "What is EPI?"
        }
    },
    "header-development": {
        link: {
            name: "Development",
            title: "Development"
        },
        component: {
            title: "Development"
        }
    },
    "header-development-developing-the-tool": {
        link: {
            name: "Development: Developing the screening tool",
            title: "Developing the screening tool",
            url: "development#developing-the-tool"
        },
        component: {
            title: "Development"
        }
    },
    "header-development-considerations-limitations": {
        link: {
            name: "Development: Considerations & limitations",
            title: "Considerations & limitations",
            url: "development#considerations-limitations"
        },
        component: {
            title: "Development"
        }
    },
    "header-development-collaborators-publications": {
        link: {
            name: "Development: Collaborators & publications",
            title: "Collaborators & publications",
            url: "development#collaborators-publications"
        },
        component: {
            title: "Development"
        }
    },
    "header-screening-tool": {
        link: {
            name: "The Screening Tool",
            title: "The Screening Tool",
            url: "screening-tool-landing"
        },
        component: {
            title: "The Screening Tool"
        }
    },
    "header-screening-tool-introduction": {
        link: {
            name: "The Screening Tool: Introduction",
            title: "Introduction",
            url: "screening-tool-landing#introduction"
        },
        component: {
            title: "The Screening Tool"
        }
    },
    "header-screening-tool-start-screening": {
        link: {
            name: "The Screening Tool: Start Screening",
            title: "Start Screening",
            url: "screening-tool-landing#start-screening"
        },
        component: {
            title: "The Screening Tool"
        }
    },
    "header-screening-tool-feedback": {
        link: {
            name: "The Screening Tool: Feedback",
            title: "Feedback",
            url: "screening-tool-landing#start-screening"
        },
        component: {
            title: "The Screening Tool"
        }
    },
    "header-faqs": {
        link: {
            name: "FAQs",
            title: "FAQs",
            url: "faqs"
        },
        component: {
            title: "FAQs"
        }
    },
    // Footer
    "footer-site-logo": {
        link: {
            name: "Site Logo",
            title: "Site Logo",
            url: "home",
            type: "internal"
        },
        component: {
            name: "footer",
            title: "Site Logo"
        }
    },
    "footer-home": {
        link: {
            name: "Home",
            title: "Home",
            url: "home",
            type: "internal"
        },
        component: {
            name: "footer",
            title: "Home"
        }
    },
    "footer-what-is-epi": {
        link: {
            name: "What is EPI?",
            title: "What is EPI?",
            url: "what-is-epi",
            type: "internal"
        },
        component: {
            name: "footer",
            title: "What is EPI?"
        }
    },
    "footer-development": {
        link: {
            name: "Development",
            title: "Development",
            url: "development",
            type: "internal"
        },
        component: {
            name: "footer",
            title: "Development"
        }
    },
    "footer-screening-tool": {
        link: {
            name: "The Screening Tool",
            title: "The Screening Tool",
            url: "screening-tool-landing",
            type: "internal"
        },
        component: {
            name: "footer",
            title: "The Screening Tool"
        }
    },
    "footer-faqs": {
        link: {
            name: "FAQs",
            title: "FAQs",
            url: "faqs",
            type: "internal"
        },
        component: {
            name: "footer",
            title: "FAQs"
        }
    },
    "footer-privacy-notice": {
        link: {
            name: "Privacy Notice",
            title: "Privacy Notice",
            url: "https://privacy.abbvie/privacy-policies/us-privacy-policy.html",
            type: "external"
        },
        component: {
            name: "CTA",
            title: "Privacy Notice",
        },
        content: {
            type: "external"
        }
    },
    "footer-accessibility-link": {
        link: {
            name: "Accessibility Statement",
            title: "Accessibility Statement",
            url: "https://www.abbvie.com/accessibility-statement.html",
            type: "external"
        },
        component: {
            name: "CTA",
            title: "Accessibility Statement",
        },
        content: {
            type: "external"
        }
    },
    "footer-contactus": {
        link: {
            name: "Contact Us",
            title: "Contact Us",
            url: "https://www.abbvie.com/contactus.html",
            type: "external"
        },
        component: {
            name: "CTA",
            title: "Contact Us",
        },
        content: {
            type: "external"
        }
    },
    "footer-terms-of-use": {
        link: {
            name: "Terms of Use",
            title: "Terms of Use",
            url: "https://www.abbvie.com/terms-of-use.html",
            type: "external"
        },
        component: {
            name: "CTA",
            title: "Terms of Use"
        },
        content: {
            type: "external"
        }
    },
    "footer-cookies-settings": {
        link: {
            name: "Cookies Settings",
            title: "Cookies Settings",
            url: "javascript:void(0);",
            type: "Internal"
        },
        component: {
            name: "CTA",
            title: "Cookies Settings"
        },
        content: {
            type: "Internal"
        }
    },
    "footer-your-privacy-choices": {
        link: {
            name: "Your Privacy Choices",
            title: "Your Privacy Choices",
            url: "https://abbviemetadata.my.site.com/AbbvieDSRM/",
            type: "external"
        },
        component: {
            name: "RTE",
            title: "Your Privacy Choices",
        },
        content: {
            type: "external"
        }
    },
    "footer-abbvie-logo": {
        link: {
            name: "AbbVie Logo",
            title: "AbbVie Logo",
            url: "https://www.abbvie.com/",
            type: "external"
        },
        component: {
            name: "footer",
            title: "AbbVie Logo"
        }
    },
    // HCP Form
    "confirm-us-hcp-yes": {
        link: {
            name: "Are you a US-based healthcare professional?: Yes",
            title: "Are you a US-based healthcare professional?: Yes",
            type: "information modal"
        },
        component: {
            name: "modal",
            title: "This content is for US healthcare professionals only",
            position: "content",
            type: "modal"
        },
        content: {
            type: "informational modal"
        },
        interaction: {
            type: "link"
        }
    },
    "confirm-us-hcp-no": {
        link: {
            name: "Are you a US-based healthcare professional?: No",
            title: "Are you a US-based healthcare professional?: No",
            type: "information modal"
        },
        component: {
            name: "modal",
            title: "This content is for US healthcare professionals only",
            position: "content",
            type: "modal"
        },
        content: {
            type: "informational modal"
        },
        interaction: {
            type: "link"
        }
    },
    "confirm-us-hcp-close": {
        link: {
            name: "Are you a US-based healthcare professional?: Close",
            title: "X",
            type: "information modal"
        },
        component: {
            name: "modal",
            title: "This content is for US healthcare professionals only",
            position: "content",
            type: "modal"
        },
        content: {
            type: "informational modal"
        },
        interaction: {
            type: "link"
        }
    },
    "what-is-your-specialty-initial": {
        link: {
            name: "dynamic",
            type: "form-initiation"
        },
        component: {
            name: "form",
            title: "This content is for US healthcare professionals only",
            position: "content",
            type: "form"
        },
        content: {
            type: "form"
        },
        interaction: {
            type: "form interaction"
        },
        form: {
            name: "US-based HCP Specialty",
            category: "interaction",
            subCategory: "more info",
            stepName: "initiation",
            fieldName: "What is your specialty?"
        }
    },
    "what-is-your-specialty-update": {
        link: {
            type: "form-interaction"
        },
        component: {
            name: "form",
            title: "This content is for US healthcare professionals only",
            position: "content",
            type: "form"
        },
        content: {
            type: "form"
        },
        interaction: {
            type: "form interaction"
        },
        form: {
            name: "US-based HCP Specialty",
            category: "interaction",
            subCategory: "more info",
            stepName: "interaction",
            fieldName: "What is your specialty?"
        }
    },
    "what-is-your-specialty-submit": {
        link: {
            name: "US-based HCP Specialty Submit",
            title: "Continue",
            type: "form-submission"
        },
        component: {
            name: "form",
            title: "This content is for US healthcare professionals only",
            position: "content",
            type: "form"
        },
        content: {
            type: "form"
        },
        interaction: {
            type: "form interaction"
        },
        mva: {
            tier: "primary",
            type: "form",
            category: "other",
            name: "US-based HCP Specialty"
        },
        form: {
            name: "US-based HCP Specialty",
            category: "interaction",
            subCategory: "more info",
            stepName: "submit"
        }
    },
    "home-discover-more-hero-button": {
        link: {
            name: "Discover more",
            title: "Discover more",
            type: "internal",
            url: "what-is-epi"
        },
        component: {
            name: "cta",
            title: "WELCOME TO Screen For EPI in CP",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },
    "home-start-screening-hero-button": {
        link: {
            name: "Start screening",
            title: "Start screening",
            type: "internal",
            url: "screening-tool-landing"
        },
        component: {
            name: "cta",
            title: "WELCOME TO Screen For EPI in CP",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },
    "home-about-this-tool-discover-more-button": {
        link: {
            name: "Discover more",
            title: "Discover more",
            type: "internal",
            url: "screening-tool-landing"
        },
        component: {
            name: "cta",
            title: "About this tool",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },
    "home-the-landscape-what-is-epi-button": {
        link: {
            name: "What is EPI?",
            title: "What is EPI?",
            type: "internal",
            url: "what-is-epi"
        },
        component: {
            name: "cta",
            title: "The landscape",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },
    "home-designed-to-support-start-screening-button": {
        link: {
            name: "Start screening",
            title: "Start screening",
            type: "internal",
            url: "screening-tool-landing"
        },
        component: {
            name: "cta",
            title: "Designed to support US healthcare professionals",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },
    "home-bottom-nav-continue-to-what-is-epi-button": {
        link: {
            name: "CONTINUE TO: What is EPI?",
            title: "CONTINUE TO...What is EPI?",
            type: "internal",
            url: "what-is-epi"
        },
        component: {
            name: "cta",
            title: "CONTINUE TO",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },
    // What is EPI?
    "what-is-epi-essentials-of-epi-link": {
        link: {
            name: "www.essentialsofepi.com",
            title: "www.essentialsofepi.com",
            type: "external",
            url: "https://essentialsofepi.com"
        },
        component: {
            name: "cta",
            title: "Want to learn more about EPI?",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },
    "what-is-epi-essentials-of-epi-button": {
        link: {
            name: "Visit Essentials of EPI website",
            title: "Visit Essentials of EPI website",
            type: "external",
            url: "https://essentialsofepi.com"
        },
        component: {
            name: "cta",
            title: "Want to learn more about EPI?",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },

    // development page
    "development-tab-developing-the-tool": {
        link: {
            name: "Developing the screening tool",
            title: "Developing the screening tool"
        },
        component: {
            title: "Developing the screening tool"
        }
    },
    "development-tab-considerations-limitations": {
        link: {
            name: "Considerations & limitations",
            title: "Considerations & limitations"
        },
        component: {
            title: "Considerations & limitations"
        }
    },
    "development-tab-collaborators-publications": {
        link: {
            name: "Collaborators & publications",
            title: "Collaborators & publications"
        },
        component: {
            title: "Collaborators & publications"
        }
    },
    "development-modal-1-open": {
        link: {
            name: "1. Patient selection - modal open",
            title: "View patient demographics"
        },
        component: {
            title: "1. Patient selection"
        }
    },
    "development-modal-1-close": {
        link: {
            name: "1. Patient selection - modal close",
            title: "X"
        },
        component: {
            title: "TABLE 1: Patient demographics"
        }
    },
    "development-modal-2-open": {
        link: {
            name: "2. Variable selection - modal open",
            title: "View candidate predictors"
        },
        component: {
            title: "2. Variable selection"
        }
    },
    "development-modal-2-close": {
        link: {
            name: "2. Variable selection - modal close",
            title: "X"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "development-modal-3-open": {
        link: {
            name: "3. CART modeling - modal open",
            title: "View predictors used"
        },
        component: {
            title: "3. CART modeling"
        }
    },
    "development-modal-3-close": {
        link: {
            name: "3. CART modeling - modal close",
            title: "X"
        },
        component: {
            title: "TABLE 3: Predictors used in the optimal screening tool"
        }
    },
    "development-modal-4-open": {
        link: {
            name: "4. Performance characteristics of optimal CART - modal open",
            title: "View confusion matrix"
        },
        component: {
            title: "4. Performance characteristics of optimal CART"
        }
    },
    "development-modal-4-close": {
        link: {
            name: "4. Performance characteristics of optimal CART - modal close",
            title: "X"
        },
        component: {
            title: "TABLE 4: 2x2 table for the optimal CART including pancreatic imaging"
        }
    },
    "development-modal-5-open": {
        link: {
            name: '5. Train/tune a "no-imaging" CART - modal open',
            title: "View confusion matrix"
        },
        component: {
            title: '5. Train/tune a "no-imaging" CART'
        }
    },
    "development-modal-5-close": {
        link: {
            name: '5. Train/tune a "no-imaging" CART - modal close',
            title: "X"
        },
        component: {
            title: "TABLE 5: 2x2 table for the CART excluding pancreatic imaging"
        }
    },
    "development-modal-6-open": {
        link: {
            name: "6. Validation - modal open",
            title: "View five-fold cross-validation"
        },
        component: {
            title: "6. Validation"
        }
    },
    "development-modal-6-close": {
        link: {
            name: "6. Validation - modal close",
            title: "X"
        },
        component: {
            title: "TABLE 6: Comparison of predictive CART models"
        }
    },
    "development-user-guide-open": {
        link: {
            name: "User guide: How to use the Screen for EPI in CP tool video - modal open",
            title: "Screen for EPI in CP tool User Guide"
        },
        component: {
            title: "Ready to begin?"
        }
    },
    "development-user-guide-close": {
        link: {
            name: "User guide: How to use the Screen for EPI in CP tool video - modal close",
            title: "User guide: How to use the Screen for EPI in CP tool video - modal close"
        },
        component: {
            title: "User guide: How to use the Screen for EPI in CP tool"
        }
    },
    "developing-the-tool-start-screening-cta": {
        link: {
            name: "Start Screening",
            title: "Start Screening",
            url: "screening-tool-landing#start-screening"
        },
        component: {
            title: "Ready to begin?"
        }
    },
    "developing-the-tool-considerations-limitations-cta": {
        link: {
            name: "Considerations & limitations: Find out more",
            title: "Find out more",
            url: "development#considerations-limitations"
        },
        component: {
            title: "Additional Information"
        }
    },
    "developing-the-tool-collaborators-publications-cta": {
        link: {
            name: "Collaborators & publications: Find out more",
            title: "Find out more",
            url: "development#collaborators-publications"
        },
        component: {
            title: "Additional Information"
        }
    },
    "developing-the-tool-table-2-accordion-1-expand": {
        link: {
            name: "Patient demographics and vital signs - Expand",
            title: "Patient demographics and vital signs - Expand"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "developing-the-tool-table-2-accordion-1-close": {
        link: {
            name: "Patient demographics and vital signs - Close",
            title: "Patient demographics and vital signs - Close"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },

    "developing-the-tool-table-2-accordion-2-expand": {
        link: {
            name: "Pancreas imaging findings - Expand",
            title: "Pancreas imaging findings - Expand"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "developing-the-tool-table-2-accordion-2-close": {
        link: {
            name: "Pancreas imaging findings - Close",
            title: "Pancreas imaging findings - Close"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "developing-the-tool-table-2-accordion-3-expand": {
        link: {
            name: "Abdominal and bowel symptoms - Expand",
            title: "Abdominal and bowel symptoms - Expand"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "developing-the-tool-table-2-accordion-3-close": {
        link: {
            name: "Abdominal and bowel symptoms - Close",
            title: "Abdominal and bowel symptoms - Close"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "developing-the-tool-table-2-accordion-4-expand": {
        link: {
            name: "Patient habits - Expand",
            title: "Patient habits - Expand"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "developing-the-tool-table-2-accordion-4-close": {
        link: {
            name: "Patient habits - Close",
            title: "Patient habits - Close"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "developing-the-tool-table-2-accordion-5-expand": {
        link: {
            name: "Clinical laboratory - Expand",
            title: "Clinical laboratory - Expand"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "developing-the-tool-table-2-accordion-5-close": {
        link: {
            name: "Clinical laboratory - Close",
            title: "Clinical laboratory - Close"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "developing-the-tool-table-2-accordion-6-expand": {
        link: {
            name: "Pancreatitis and gallstone history - Expand",
            title: "Pancreatitis and gallstone history - Expand"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "developing-the-tool-table-2-accordion-6-close": {
        link: {
            name: "Pancreatitis and gallstone history - Close",
            title: "Pancreatitis and gallstone history - Close"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "developing-the-tool-table-2-accordion-7-expand": {
        link: {
            name: "Concurrent medications - Expand",
            title: "Concurrent medications - Expand"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "developing-the-tool-table-2-accordion-7-close": {
        link: {
            name: "Concurrent medications - Close",
            title: "Concurrent medications - Close"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "developing-the-tool-table-2-accordion-8-expand": {
        link: {
            name: "Family history - Expand",
            title: "Family history - Expand"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "developing-the-tool-table-2-accordion-8-close": {
        link: {
            name: "Family history - Close",
            title: "Family history - Close"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "developing-the-tool-table-2-accordion-9-expand": {
        link: {
            name: "Genetic risk factor - Expand",
            title: "Genetic risk factor - Expand"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "developing-the-tool-table-2-accordion-9-close": {
        link: {
            name: "Genetic risk factor - Close",
            title: "Genetic risk factor - Close"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "developing-the-tool-table-2-accordion-10-expand": {
        link: {
            name: "Co-morbidities - Expand",
            title: "Co-morbidities - Expand"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    "developing-the-tool-table-2-accordion-10-close": {
        link: {
            name: "Co-morbidities - Close",
            title: "Co-morbidities - Close"
        },
        component: {
            title: "TABLE 2: Candidate predictors included in model"
        }
    },
    // Considerations & Limitations
    "considerations-limitations-developing-the-tool-cta": {
        link: {
            name: "Development of the tool: Find out more",
            title: "Find out more",
            url: "development#developing-the-tool"
        },
        component: {
            title: "Additional Information"
        }
    },
    "considerations-limitations-collaborators-publications-cta": {
        link: {
            name: "Collaborators & publications: Find out more",
            title: "Find out more",
            url: "development#collaborators-publications"
        },
        component: {
            title: "Additional Information"
        }
    },
    // Collaborators & Publications
    "collaborators-publications-developing-the-tool-cta": {
        link: {
            name: "Development of the tool: Find out more",
            title: "Find out more",
            type: "internal",
            url: "development#developing-the-tool"
        },
        component: {
            name: "cta",
            title: "Additional Information",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },
    "collaborators-publications-considerations-limitations-cta": {
        link: {
            name: "Considerations & limitations: Find out more",
            title: "Find out more",
            type: "internal",
            url: "development#considerations-limitations"
        },
        component: {
            name: "cta",
            title: "Additional Information",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },

    // Screening Tool Landing
    "screening-tool-landing-tab-introduction": {
        link: {
            name: "Introduction",
            title: "Introduction"
        },
        component: {
            title: "Introduction"
        }
    },
    "screening-tool-landing-tab-start-screening": {
        link: {
            name: "Start Screening",
            title: "Start Screening"
        },
        component: {
            title: "Start Screening"
        }
    },
    "screening-tool-landing-tab-feedback": {
        link: {
            name: "Feedback",
            title: "Feedback"
        },
        component: {
            title: "Feedback"
        }
    },

    // Introduction
    "screening-tool-landing-introduction-start-screening-top-cta": {
        link: {
            name: "Start screening",
            title: "Start screening",
            type: "internal",
            url: "screening-tool-landing#start-screening"
        },
        component: {
            name: "cta",
            title: "Introducing the Screen for EPI in CP tool for clinicians",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },
    "screening-tool-landing-introduction-user-guide-how-to-use-video-button-cta": {
        link: {
            name: "User guide: How to use the Screen for EPI in CP tool video - modal open",
            title: "User guide: How to use the Screen for EPI in CP tool video - modal open",
            type: "information modal"
        },
        component: {
            name: "modal",
            title: "User guide: How to use the Screen for EPI in CP tool",
            position: "content",
            type: "modal"
        },
        content: {
            type: "informational modal"
        },
        interaction: {
            type: "link"
        }
    },
    "screening-tool-landing-introduction-user-guide-how-to-use-ready-to-start-cta": {
        link: {
            name: "User guide: How to use the Screen for EPI in CP tool video - modal open",
            title: "Screen for EPI in CP tool User Guide",
            type: "information modal"
        },
        component: {
            name: "modal",
            title: "Ready to begin?",
            position: "content",
            type: "modal"
        },
        content: {
            type: "informational modal"
        },
        interaction: {
            type: "link"
        }
    },

    "screening-tool-landing-introduction-user-guide-close": {
        link: {
            name: "User guide: How to use the Screen for EPI in CP tool video - modal close",
            title: "User guide: How to use the Screen for EPI in CP tool video - modal close",
            type: "information modal"
        },
        component: {
            name: "modal",
            title: "User guide: How to use the Screen for EPI in CP tool",
            position: "content",
            type: "modal"
        },
        content: {
            type: "informational modal"
        },
        interaction: {
            type: "link"
        }
    },
    "screening-tool-landing-introduction-start-screening-bottom-cta": {
        link: {
            name: "Start screening",
            title: "Start screening",
            type: "internal",
            url: "screening-tool-landing#start-screening"
        },
        component: {
            name: "cta",
            title: "Ready to begin?",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },
    "screening-tool-landing-introduction-variables-accordion-expand": {
        link: {
            name: "View variables included in the decision tool - Expand",
            title: "View variables included in the decision tool - Expand",
            type: "internal"
        },
        component: {
            name: "cta",
            title: "View variables included in the decision tool",
            position: "content",
            type: "content"
        },
        content: {
            type: "accordion"
        },
        interaction: {
            type: "link"
        }
    },
    "screening-tool-landing-introduction-variables-accordion-close": {
        link: {
            name: "View variables included in the decision tool - Close",
            title: "View variables included in the decision tool - Close",
            type: "internal"
        },
        component: {
            name: "cta",
            title: "View variables included in the decision tool",
            position: "content",
            type: "content"
        },
        content: {
            type: "accordion"
        },
        interaction: {
            type: "link"
        }
    },
    "screening-tool-landing-introduction-print-variables": {
        link: {
            name: "Print variables",
            title: "Print variables",
            type: "download",
            url: "assets/pdfs/Variables-01.pdf"
        },
        component: {
            name: "cta",
            title: "View variables included in the decision tool",
            position: "content",
            type: "content"
        },
        content: {
            type: "PDF"
        },
        interaction: {
            type: "file download"
        },
        mva: {
            tier: "primary",
            type: "download",
            category: "Other Resources",
            name: "Print variables"
        }
    },
    "screening-tool-landing-introduction-variables-list-modal-open": {
        link: {
            name: "View the full list of variables - modal open",
            title: "View the full list of variables",
            type: "information modal"
        },
        component: {
            name: "modal",
            title: "View variables included in the decision tool",
            position: "content",
            type: "modal"
        },
        content: {
            type: "informational modal"
        },
        interaction: {
            type: "link"
        }
    },
    "screening-tool-landing-introduction-variables-list-modal-close": {
        link: {
            name: "View the full list of variables - modal close",
            title: "X",
            type: "information modal"
        },
        component: {
            name: "modal",
            title: "TABLE 2: Candidate predictors included in model",
            position: "content",
            type: "modal"
        },
        content: {
            type: "informational modal"
        },
        interaction: {
            type: "link"
        }
    },
    // Start Screening page
    "screening-tool-landing-start-screening-start-screening-cta": {
        link: {
            name: "Start screening",
            title: "Start screening",
            type: "internal",
            url: "screening-tool"
        },
        component: {
            name: "cta",
            title: "Start a new screening",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },
    "screening-tool-landing-start-screening-user-guide-link-cta": {
        link: {
            name: "User guide: How to use the Screen for EPI in CP tool video - modal open",
            title: "watch the user guide",
            type: "information modal"
        },
        component: {
            name: "modal",
            title: "Start a new screening",
            position: "content",
            type: "modal"
        },
        content: {
            type: "informational modal"
        },
        interaction: {
            type: "link"
        }
    },
    "screening-tool-landing-start-screening-user-guide-button-cta": {
        link: {
            name: "User guide: How to use the Screen for EPI in CP tool video - modal open",
            title: "User guide: How to use the Screen for EPI in CP tool video - modal open",
            type: "information modal"
        },
        component: {
            name: "modal",
            title: "User guide: How to use the Screen for EPI in CP tool",
            position: "content",
            type: "modal"
        },
        content: {
            type: "informational modal"
        },
        interaction: {
            type: "link"
        }
    },
    "screening-tool-landing-start-screening-user-guide-modal-close": {
        link: {
            name: "User guide: How to use the Screen for EPI in CP tool video - modal close",
            title: "User guide: How to use the Screen for EPI in CP tool video - modal close",
            type: "information modal"
        },
        component: {
            name: "modal",
            title: "User guide: How to use the Screen for EPI in CP tool",
            position: "content",
            type: "modal"
        },
        content: {
            type: "informational modal"
        },
        interaction: {
            type: "link"
        }
    },
    "screening-tool-landing-start-screening-continue-screening-submit": {
        link: {
            name: "Progress code submit",
            title: "Continue screening",
            type: "form-submission"
        },
        component: {
            name: "form",
            title: "Continuing an existing screening",
            position: "content",
            type: "form"
        },
        content: {
            type: "form"
        },
        interaction: {
            type: "form interaction"
        },
        mva: {
            tier: "primary",
            type: "form",
            category: "other",
            name: "Continuing an existing screening"
        },
        form: {
            name: "Continuing an existing screening",
            category: "Services",
            subCategory: "Symptom Checker",
            stepName: "submit"
        }
    },
    "results-page-repeat-screening-tool-link": {
        link: {
            name: "repeat the EPI Screening Tool",
            title: "repeat the EPI Screening Tool",
            type: "internal",
            url: "screening-tool-landing#start-screening"
        },
        component: {
            name: "cta",
            title: "Your decision tree responses",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },
    "results-page-download-summary": {
        link: {
            name: "Download summary",
            title: "Download summary",
            type: "download",
            url: "screening-tool-landing#start-screening"
        },
        component: {
            name: "cta",
            title: "Download result",
            position: "content",
            type: "content"
        },
        content: {
            type: "PDF"
        },
        interaction: {
            type: "file download"
        },
        mva: {
            tier: "primary",
            type: "download",
            category: "Test Score Tracker",
            name: "Download result"
        }
    },
    "results-page-provide-feedback": {
        link: {
            name: "Provide feedback",
            title: "Provide feedback",
            type: "internal",
            url: "screening-tool-landing#feedback"
        },
        component: {
            name: "cta",
            title: "Provide feedback",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },
    "results-page-start-another-test-button": {
        link: {
            name: "Start another test",
            title: "Start another test",
            type: "internal",
            url: "screening-tool-landing#start-screening"
        },
        component: {
            name: "cta",
            title: "Start another test",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },
    // Feedback Form camelCased section of feedback form Ids must match ids found in the feedback component
    "feedback-form-hcpSpecialty": {
        link: {
            name: "What is your specialty:"
        },
        form: {
            fieldName: "What is your specialty?"
        }
    },
    "feedback-form-otherSpecialty": {
        link: {
            name: "What is your specialty?"
        },
        form: {
            fieldName: "What is your specialty?"
        }
    },
    "feedback-form-howManyPatients": {
        link: {
            name: "How many patients with CP do you see in clinic in a month?:"
        },
        form: {
            fieldName: "How many patients with CP do you see in clinic in a month?"
        }
    },
    "feedback-form-diagnoseTreat": {
        link: {
            name: "Do you currently diagnose and/or treat EPI?:"
        },
        form: {
            fieldName: "Do you currently diagnose and/or treat EPI?"
        }
    },
    "feedback-form-statusAlignment": {
        link: {
            name: "If you know the EPI status of your patient, does it align with the Screen for EPI in CP prediction?:"
        },
        form: {
            fieldName:
                "If you know the EPI status of your patient, does it align with the Screen for EPI in CP prediction?"
        }
    },
    "feedback-form-nextSteps": {
        link: {
            name: 'For a "more likely has EPI" prediction what is your next step for your patient?:'
        },
        form: {
            fieldName: 'For a "more likely has EPI" prediction what is your next step for your patient?'
        }
    },
    "feedback-form-expectations": {
        link: {
            name: "Did the Screen for EPI in CP tool meet your expectations?:"
        },
        form: {
            fieldName: "Did the Screen for EPI in CP tool meet your expectations?"
        }
    },
    "feedback-form-recommend": {
        link: {
            name: "Would you recommend the use of the Screen for EPI in CP tool to other clinicians?:"
        },
        form: {
            fieldName: "Would you recommend the use of the Screen for EPI in CP tool to other clinicians?"
        }
    },
    "feedback-form-intuitiveEasy": {
        link: {
            name: "Did you find this website to be intuitive and easy to navigate?:"
        },
        form: {
            fieldName: "Did you find this website to be intuitive and easy to navigate?"
        }
    },
    "feedback-form-clearAccurate": {
        link: {
            name: "Is the information presented in this website clear and accurate?:"
        },
        form: {
            fieldName: "Is the information presented in this website clear and accurate?"
        }
    },
    "feedback-form-scientificContent": {
        link: {
            name: "In terms of scientific content, was there…:"
        },
        form: {
            fieldName: "In terms of scientific content, was there…"
        }
    },
    "feedback-form-educationalValue": {
        link: {
            name: "How would you rate the educational value of this website?:"
        },
        form: {
            fieldName: "How would you rate the educational value of this website?"
        }
    },
    "feedback-form-submit-success": {
        link: {
            name: "Your feedback submit",
            title: "Send",
            type: "form-submission"
        },
        component: {
            name: "form",
            title: "Your feedback",
            position: "content",
            type: "form"
        },
        content: {
            type: "form"
        },
        interaction: {
            type: "form interaction"
        },
        mva: {
            tier: "primary",
            type: "form",
            category: "other",
            name: "Your feedback"
        },
        form: {
            name: "Your feedback",
            category: "interaction",
            subCategory: "more info",
            stepName: "submit",
            stepNumber: "3"
        }
    },
    "screening-tool-base-form-interaction": {
        link: {
            type: "form-interaction"
        },
        component: {
            name: "form",
            title: "The Screen for EPI in CP tool",
            position: "content",
            type: "form"
        },
        content: {
            type: "form"
        },
        interaction: {
            type: "form interaction"
        },
        form: {
            name: "The Screen for EPI in CP tool",
            category: "Services",
            subCategory: "Symptom Checker",
            stepName: "interaction"
        }
    },
    "screening-tool-base-cta-interaction": {
        link: {
            type: "internal"
        },
        component: {
            name: "cta",
            title: "The Screen for EPI in CP tool",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },
    // FAQs Page
    "faqs-developing-the-screening-tool-link": {
        link: {
            name: "Developing the screening tool",
            title: "Developing the screening tool",
            type: "internal",
            url: "development#developing-the-tool"
        },
        component: {
            name: "cta",
            title: "What variables may be needed to complete the Screen for EPI in CP tool?",
            position: "content",
            type: "content"
        },
        content: {
            type: "link"
        },
        interaction: {
            type: "link"
        }
    },
    "faqs-accordion-base": {
        link: {
            type: "internal"
        },
        component: {
            name: "cta",
            title: "Common questions",
            position: "content",
            type: "content"
        },
        content: {
            type: "accordion"
        },
        interaction: {
            type: "link"
        }
    },
    "faqs-accordion-1": {
        link: {
            name: "What variables may be needed to complete the Screen for EPI in CP tool?",
            title: "What variables may be needed to complete the Screen for EPI in CP tool?"
        }
    },
    "faqs-accordion-2": {
        link: {
            name: "Can I use this tool in patients who had history of several acute pancreatitis episodes?",
            title: "Can I use this tool in patients who had history of several acute pancreatitis episodes?"
        }
    },
    "faqs-accordion-3": {
        link: {
            name: "What criteria establish definite chronic pancreatitis (CP)?",
            title: "What criteria establish definite chronic pancreatitis (CP)?"
        }
    },
    "faqs-accordion-4": {
        link: {
            name: "Can I use the tool when my patient is already taking pancreatic enzymes?",
            title: "Can I use the tool when my patient is already taking pancreatic enzymes?"
        }
    },
    "faqs-accordion-5": {
        link: {
            name: "What is steatorrhea?",
            title: "What is steatorrhea?"
        }
    },
    "faqs-accordion-6": {
        link: {
            name: "Do I need an EPI diagnostic test result for the Screen for EPI in CP tool from my patient?",
            title: "Do I need an EPI diagnostic test result for the Screen for EPI in CP tool from my patient?"
        }
    }
};
